import { Component, Input } from '@angular/core';

@Component({
  selector: 'unicon-recurring-customer-chip',
  templateUrl: './recurring-customer-chip.component.html',
})
export class RecurringCustomerChipComponent {
  @Input() recurring: boolean = false;
}
